<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6" style="text-align: left;"  >
                Ms solutions © {{year}}
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    version 1.4.1
                </div>
            </div>
        </div>
    </div>
</footer>